import React, { useState, useEffect } from "react";
import Trending from "../trending/Trending.jsx";
import { Row, Col, Card, CardImg, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Spinner from "../utilities/Spinner.jsx";
import useFetch from "../hooks/useFetch";
import { useParams } from "react-router-dom";
import defaultImage from "../../assets/item-1.png";
import axiosInstance from "../utilities/axiosInstance.js";

function ArticleDetail({ articles }) {
    const params = useParams();
    const article_id = params.article_id;

    const [article, setArticle] = useState(null);
    const content = useFetch(`articles/${article_id}/`);

    const fetchArticle = async () => {
        const response = await axiosInstance.get(`articles/${article_id}/`);
        setArticle(response.data)
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchArticle();
    }, [article_id]);

    const moreArticles = articles.filter((element) => element.id != article_id);

    function getArticleUrl(article_id) {
        let articleUrl = '/article/' + article_id + '/';
        return articleUrl;
    }

    return (
        <Container className="pt-4">
            {!article ? (
                <Spinner />
            ) : (
                <Row>
                    <Col sm={9}>
                        <Row>
                            <Container style={{ maxHeight: '45rem' }}>
                                <img src={article.image ?? defaultImage} alt="" className="img-responsive w-100" />
                            </Container>
                            <Container className="mb-4">
                                <h2 className="m-4">{article.title}</h2>
                                <div>{article.content}</div>
                            </Container>
                        </Row>
                    </Col>
                    <Col sm={3}>
                        <Container>
                            <h4 style={{ textDecoration: 'underline' }}>More Articles</h4>
                            <Row>
                                {moreArticles && moreArticles.map((article) => {
                                    return (
                                        <Col
                                            sm={12}
                                            className="my-4"
                                            key={article.id}
                                            data-aos="fade-up"
                                        >
                                            <NavLink to={getArticleUrl(article.id)} className="text-dark d-block">
                                                <Card>
                                                    <CardImg
                                                        src={`${article.image}`}
                                                    />
                                                    <Card.Body>
                                                        <Card.Title style={{ textAlign: 'left' }}>{article.title}</Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </NavLink>

                                        </Col>
                                    );
                                })
                                }
                            </Row>
                        </Container>
                    </Col>
                </Row>
            )}    </Container>
    );
}

export default ArticleDetail;
